import { Checkbox, CheckboxProps } from '@mui/material'
import React, { FC, useCallback, useContext, useEffect } from 'react'

import useAccessTokenAndShopId from '../../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { NotificationContext } from '../../../providers'
import { useUpdateRepairOrderMutation } from '../../../redux/api'
import { RepairOrderEntry } from '../../../sdk'
import { ModifyObjectType } from '../../../utils'

type Props = ModifyObjectType<
  CheckboxProps,
  {
    repairOrder: RepairOrderEntry
  }
>

export const RepairOrderTaxExemptCheckbox: FC<Props> = ({
  repairOrder,
  ...props
}) => {
  const { accessToken } = useAccessTokenAndShopId()
  const { setNotice } = useContext(NotificationContext)
  const [updateRepairOrder, { isSuccess }] = useUpdateRepairOrderMutation()
  const handleTaxExemptChange = useCallback(
    async (taxExempt: boolean) => {
      await updateRepairOrder({
        authorization: accessToken,
        repairOrderEntry: {
          ...repairOrder,
          info: { ...repairOrder.info, taxExempt }
        }
      })
    },
    [accessToken, repairOrder, updateRepairOrder]
  )
  useEffect(() => {
    if (isSuccess) {
      setNotice('Repair order has been updated.')
    }
  }, [isSuccess, setNotice])
  return (
    <>
      {repairOrder && (
        <Checkbox
          checked={!repairOrder.info?.taxExempt}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            handleTaxExemptChange(!event.target.checked)
          }}
          {...props}
        />
      )}
    </>
  )
}
